<template>
    <section class="side-menu-container">
        <section class="side-menu-title">
            <button type="button" @click="$router.push({ name: 'report.basics.all' })">
                <i class="fal fa-chart-bar"/>
            </button>
            <h3>Relatórios</h3>
        </section>
        <section class="side-menu">
            <router-link :to="{ name: 'report.basics.all' }">
                <span><span class="tag" :style="getCategoryStyle(null, true)"/>Todos</span>
                <span><i class="fal fa-chevron-right"/></span>
            </router-link>
            <router-link
                v-for="(item, index) in sideMenu"
                :key="index"
                :to="{
                    name: 'report.basics.dynamic',
                    params: { title: item.title.toLowerCase() },
                }"
            >
                <span><span class="tag" :style="getCategoryStyle(item, false)"/>{{ item.title }}</span>
                <span><i class="fal fa-chevron-right"/></span>
            </router-link>
            <div v-if="loader.getReports" class="load-container">
                <ui-load-indicator :h="30" color="#69D296" :stroke="8" />
            </div>
        </section>
    </section>
</template>

<script>
	import { s3Filesystem } from '@/services/axios'
	import { uiLoadIndicator } from '@/components/ui'

	const defaultLoader = () => ({
		getReports: true,
	})

	export default {
		name: 'side-menu',

		components: {
			uiLoadIndicator,
		},

		data() {
			return {
				sideMenu: [],
				loader: { ...defaultLoader() },
			}
		},

		async created() {
			await this.getReports()
			this.loader.getReports = false
		},

		methods: {
			// Request athena reports list in the AWS
			async getReports() {
				try {
					const response = await s3Filesystem.getAthenaReports()
					this.$root.$emit('athena-reports', response)

					response.data.forEach((report) => {
						let toAdd = {
							title: report.title.charAt(0) + report.title.toLowerCase().slice(1), // Title capitalize
							color:
								'#' +
								((Math.random() * 0xffffff) << 0).toString(16).padStart(6, '0'), // Generate a random hex color for this category
						}

						// Add category
						this.sideMenu.push(toAdd)
					})

					this.prepareMenu()
				} catch {
					this.loader.getReports = false
				}
			},

			// Prepare menu, delete repeated categories and etc
			prepareMenu() {
				let withoutDuplicateMenu = []

				this.sideMenu.forEach((menuItem) => {
					// If its greater than -1, it found the duplicate
					// menu and returned the index
					const hasDuplicateMenu =
						withoutDuplicateMenu.findIndex((menuItem2) => {
							return menuItem.title == menuItem2.title
						}) > -1

					if (!hasDuplicateMenu) withoutDuplicateMenu.push(menuItem)
				})

				this.sideMenu = withoutDuplicateMenu
			},

			// Set category tag color
			getCategoryStyle(item, defaultCategory) {
				if (defaultCategory) return { backgroundColor: '#bbb' }

				return { backgroundColor: item.color }
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
